import React from 'react';
import {getLoadingSpan} from "../../../utils/loading/loading";

const DataLoading: React.FC = () => {
  return (
    <div className='text-c-blue'>{getLoadingSpan()} Loading</div>
  )
};

export default DataLoading;